// Компонент кнопки "?" — контекстная помощь для текущей страницы
import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover, Button, Typography, Divider } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { getHelpByPath, helpSections } from './helpData';

const { Text, Title } = Typography;

/* ─── Плавающая кнопка ? (контекстная для текущей страницы) ─── */
const HelpButton: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const helpItem = getHelpByPath(location.pathname);

  if (!helpItem) return null;

  const content = (
    <div style={{ maxWidth: 320 }}>
      <Title level={5} style={{ margin: 0 }}>{helpItem.title}</Title>
      <Divider style={{ margin: '8px 0' }} />
      <Text>{helpItem.shortDesc}</Text>
      <div style={{ marginTop: 12 }}>
        <Button
          type="link"
          size="small"
          style={{ padding: 0 }}
          onClick={() => navigate(`/help#${helpItem.id}`)}
        >
          Подробнее →
        </Button>
      </div>
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomRight">
      <Button
        type="text"
        icon={<QuestionCircleOutlined style={{ fontSize: 20 }} />}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </Popover>
  );
};

/* ─── Встраиваемая иконка ? рядом с заголовком ─── */
interface HelpTooltipInlineProps {
  sectionId: string;
}

export const HelpTooltipInline: React.FC<HelpTooltipInlineProps> = ({ sectionId }) => {
  const navigate = useNavigate();
  const helpItem = helpSections.find((s) => s.id === sectionId);

  if (!helpItem) return null;

  const content = (
    <div style={{ maxWidth: 300 }}>
      <Text strong>{helpItem.title}</Text>
      <Divider style={{ margin: '6px 0' }} />
      <Text style={{ fontSize: 13 }}>{helpItem.shortDesc}</Text>
      <div style={{ marginTop: 10 }}>
        <Button
          type="link"
          size="small"
          style={{ padding: 0, fontSize: 13 }}
          onClick={() => navigate(`/help#${helpItem.id}`)}
        >
          Подробнее →
        </Button>
      </div>
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomLeft">
      <QuestionCircleOutlined
        style={{
          fontSize: 16,
          color: '#1890ff',
          cursor: 'pointer',
          marginLeft: 8,
          verticalAlign: 'middle',
        }}
      />
    </Popover>
  );
};

export default HelpButton;
